var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoImportantPlaces(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 253,
    height: 159,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#no-important-places_svg__clip0_1800_2980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.59 90.777c3.66 0 6.63 2.97 6.63 6.63 0 3.66-2.97 6.63-6.63 6.63-3.66 0-6.64-2.97-6.64-6.63 0-3.66 2.97-6.63 6.64-6.63zM149.53 102.797c3.22-.08 5.7 2.07 5.45 9.42s.02 22.87.02 22.87-12.98 3.88-34.28-1.41c-.25-8.75-.99-20.57-.99-20.57s9.57-1.72 10.48-10.31c0 0 16.1.09 19.32 0zM110.15 52.017s-5.81 5.04-10.72 15.66c-5.71 12.32-20.14 16.3-20.14 16.3s-2.64-5.29-7.04-10.2c-8.1-9.02-6.11-22.17-6.11-22.17 18.08-9.82 44.01.41 44.01.41zM174.3 63.497l14.7 19.62-25.76 19.68s-2.81-11.31-13.71-8.58c5.37-6.69 8.92-10.24 9.17-15.36.25-5.12.25-7.14.08-8.03 1.9-1.14 15.52-7.33 15.52-7.33z",
    fill: "#303036"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.43 146.727c18.72 0 32.15-5.94 42.94-5.94s20.25 12.33 20.25 12.33l47.34-90.94s-22.45-26.86-50.42-26.86c-27.97 0-34.79 13.87-60.11 13.87s-32.14-13.87-60.11-13.87-50.42 26.86-50.42 26.86l47.34 90.94s9.47-12.33 20.26-12.33c10.79 0 24.22 5.94 42.93 5.94z",
    stroke: "#303036",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.64 137.357c8.38 1.81 17.79 3.8 26.68 3.8 6.14 0 12.21-.91 17.92-2.07 8.78-1.77 16.73-4.11 22.83-4.56 1.04-.08 2.03-.11 2.96-.06 10.24.49 18.45 8.59 18.45 8.59l23.26-44.16 18.52-35.15s-15.52-20-38.54-22.59c-1.59-.18-3.23-.28-4.89-.28-1.16 0-2.29.03-3.39.08-14.94.71-25.04 6.03-36.2 9.77-6.29 2.11-12.91 3.72-20.92 3.72-5.53 0-10.36-.75-14.85-1.9-14.42-3.66-25.4-11.38-44.98-11.38-9.07 0-17.21 2.78-23.94 6.39-12.33 6.6-19.95 15.94-19.95 15.94l28.97 55.42 12.45 23.81s4.64-5.7 12.52-7.64c1.12-.28 2.31-.48 3.57-.58 4.77-.37 11.7 1.17 19.53 2.85z",
    stroke: "#303036",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.55 47.557s-1.33 19.79 10.01 32.68c3.07 3.49 5.15 6.64 6.34 9.72 3.23 8.31.07 16.15-7.33 28.96v.01",
    stroke: "#303036",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9 89.957s18.43-1.03 27.13-14.68c3.13-4.9 6.52-10 10.31-14.11 1.79-1.95 3.66-3.68 5.64-5.07 2.93-2.07 6.08-3.38 9.49-3.54M124.6 97.407c0 5.88-4.61 10.68-10.4 11-.2 0-.41.01-.61.01-6.08 0-11.01-4.93-11.01-11.01 0-5.82 4.52-10.59 10.24-10.98.26-.02.51-.03.77-.03 6.08 0 11.01 4.93 11.01 11.01v0zM112.82 86.397l-.48-25.23M114.25 108.967l.49 9.96.9 18.43v.01M114.74 118.927l-22.2 16.16M124.6 97.407s8.16.04 16.07.17c3.98.06 7.89.15 10.68.27 5.71.24 7.73 6.01 8.37 12.41.55 5.44.11 11.33.11 14.67 0 7.27.41 14.16.41 14.16",
    stroke: "#303036",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.67 97.577s5.9-5.99 9.85-12.02c1.53-2.32 2.76-4.66 3.25-6.65.78-3.15-.1-6.69-.07-10.68.03-5.07 1.48-10.85 9.54-17.5",
    stroke: "#303036",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.98 56.097s27.07 29.46 32.54 29.46h.01M153.7 68.227c.53.07 11.47-4.22 22.87-10.41 8.92-4.85 18.13-10.86 22.87-16.86M207.73 41.147l-.01.01c-.15.47-10.4 30.44 10.35 50.54 2.68 2.59 5.87 5.02 9.67 7.2",
    stroke: "#303036",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.07 134.517s.36-4.31 1.24-11.35c.89-7.05 9.53-3.63 18.12-2.31 3.98.61 7.62-5.59 10.4-12.44 3.16-7.82 5.18-16.48 5.24-16.72v-.01",
    stroke: "#303036",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.57 57.817l18.97 26.48 17.28 24.12",
    stroke: "#303036",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.55 84.297h-.01l-35.82 25.96M66.14 51.607s-1.99 13.15 6.11 22.17c4.4 4.91 7.04 10.2 7.04 10.2s14.43-3.98 20.14-16.3c4.91-10.62 10.72-15.66 10.72-15.66s-25.93-10.23-44.01-.41v0zM120.22 97.407c0 3.66-2.97 6.63-6.63 6.63-3.66 0-6.64-2.97-6.64-6.63 0-3.66 2.97-6.63 6.64-6.63 3.67 0 6.63 2.97 6.63 6.63zM174.3 63.497l14.7 19.62-25.76 19.68s-2.81-11.31-13.71-8.58c5.37-6.69 8.92-10.24 9.17-15.36.25-5.12.25-7.14.08-8.03 1.9-1.14 15.52-7.33 15.52-7.33zM130.21 102.797s16.1.09 19.32 0c3.22-.08 5.7 2.07 5.45 9.42s.02 22.87.02 22.87-12.98 3.88-34.28-1.41c-.25-8.75-.99-20.57-.99-20.57s9.57-1.72 10.48-10.31z",
    stroke: "#303036",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.164 68.232c-6.567 0-11.89 5.323-11.89 11.89s7.706 17.174 11.89 21.232c4.239-4.168 11.89-14.665 11.89-21.232s-5.323-11.89-11.89-11.89zm0 18.771a6.826 6.826 0 110-13.652 6.826 6.826 0 010 13.652zM92.541 89.953c-6.567 0-11.89 5.323-11.89 11.89s7.706 17.174 11.89 21.232c4.239-4.168 11.89-14.665 11.89-21.232s-5.323-11.89-11.89-11.89zm0 18.771a6.826 6.826 0 110-13.652 6.826 6.826 0 010 13.652zM92.541 30.995c-6.567 0-11.89 5.323-11.89 11.89s7.706 17.174 11.89 21.232c4.239-4.168 11.89-14.665 11.89-21.232s-5.323-11.89-11.89-11.89v0zm0 18.771a6.826 6.826 0 110-13.652 6.826 6.826 0 010 13.652z",
    fill: "#fff",
    stroke: "#303036",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.259 138.958c1.707-2.626 4.458-.838 6.165-3.464 1.707-2.627-1.044-4.415.664-7.042 1.708-2.627 4.459-.839 6.167-3.467 1.708-2.628-1.044-4.415.664-7.042 1.709-2.629 4.46-.84 6.169-3.469 1.709-2.629-1.042-4.417.666-7.046M13.128 23.863v26.755M-.25 37.24h26.755M3.668 46.7l18.919-18.919M22.587 46.7L3.668 27.781",
    stroke: "#303036",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.59 6.23c-2.204 17.061-17.633 27.07-17.633 27.07M172.792 10.358l-3.2-4.608-4.197 3.849",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "no-important-places_svg__clip0_1800_2980"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h253v159H0z"
  })))));
}
export default SvgNoImportantPlaces;